// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"60":"819111741752ae1b","485":"0bfc49ca711609c0","589":"c09cbc9e6a4f25db","670":"0559f6b5184c06bb","778":"6d113fb91a4f4e75","870":"9b30b221188f47c0","873":"df565a4171c0f103"}[chunkId] + ".js";
};